import { useTranslate } from '@growtherapy/i18n';
import { Body, Button, Eyebrow, Skeleton, Subhead } from '@growtherapy/sprout-ui';

import { formatNextAppointmentDateTime } from '../schedule-appointment/utils';

const TEXT_CLASS = 'rebrand:text-text-inverse arc:text-text-inverse';
const MUTED_TEXT_CLASS = 'uppercase rebrand:text-text-inverseMuted arc:text-text-inverseMuted';

type WaitingRoomScheduleNudgeProps = {
  clientName: string;
  nextAppointmentTimeStart?: string | null;
  isNextAppointmentLoading: boolean;
  onScheduleNextSession: () => void;
};

export function WaitingRoomScheduleNudge({
  clientName,
  nextAppointmentTimeStart,
  isNextAppointmentLoading,
  onScheduleNextSession,
}: WaitingRoomScheduleNudgeProps) {
  const t = useTranslate();

  return (
    <div className='gap-250 flex w-full flex-col'>
      <Subhead.Default as='h2' className={TEXT_CLASS} mask='exclude'>
        {t('telehealth-core:waitingRoom.sessionCompleteWithName', { name: clientName })}
      </Subhead.Default>
      <div className='flex w-full items-center justify-between'>
        <div className='min-w-0'>
          <Eyebrow.Large className={MUTED_TEXT_CLASS}>{t('telehealth-core:waitingRoom.nextSession')}</Eyebrow.Large>
          {isNextAppointmentLoading ? (
            <>
              <Skeleton className='m-0 h-6 w-48' />
              <span className='sr-only'>{t('telehealth-core:core.loading')}</span>
            </>
          ) : (
            <Body.Default className={TEXT_CLASS}>
              {nextAppointmentTimeStart
                ? formatNextAppointmentDateTime(nextAppointmentTimeStart)
                : t('telehealth-core:waitingRoom.noSessionScheduled')}
            </Body.Default>
          )}
        </div>
        {!isNextAppointmentLoading && !nextAppointmentTimeStart && (
          <Button use='secondary' size='sm' contained className='shrink-0' onClick={onScheduleNextSession}>
            {t('telehealth-core:waitingRoom.scheduleNextSession')}
          </Button>
        )}
      </div>
    </div>
  );
}
